import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { Modal } from "react-bootstrap";
import MapContainer from "../Page/MapContainer";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { toast } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { APIURL, APIURLCOT } from "../../../Config";
import SearchDetails from "../../SearchDetails";

function CaPending() {
  const token = localStorage.getItem("token");
  const emailid = localStorage.getItem("emailId");
  const [activeTab, setActiveTab] = useState("tab1");

  const [tvrPending, setTvrPending] = useState([]);
  const [tvrRejected, setTvrRejected] = useState([]);
  const [neftSuccessData, setNeftSuccessData] = useState([]);
  const [instantDisburse, setInstantDisburse] = useState([]);
  const [neftRejectedData, setNeftRejectedData] = useState([]);
  const [reHitPennyDrop, setReHitPennyDrop] = useState([]);
  const [data, setData] = useState([]);
  const [pdData, setpdData] = useState({});
  const [allDoc, setAllDoc] = useState([]);
  const [staffId, setStaffId] = useState("");
  const [eqfexData, setEqfexData] = useState([]);
  const [googleData, setGoogleData] = useState([]);

  const [isLoader, setIsLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [showPrePage, setShowPrePage] = useState(100);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPrePage,
  });
  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const [showModalSA, setShowModalSA] = useState(false);
  const [showModalImg, setShowModalImg] = useState(false);
  const [imgUrl, setImgUrl] = useState({});
  const [limitExtend, setLimitExtend] = useState("");
  const [dataSA, setDataSA] = useState({});

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [furtherStatus, setFurtherStatus] = useState("4");
  const [remark, setRemark] = useState("");
  const [password, setPassword] = useState("");
  const [clientPhotoBase64, setClientPhotoBase64] = useState(null);
  const [approve, setApprove] = useState("");
  const [mapValue, setMapValue] = useState("");
  const [addharmesg, setAddharmesg] = useState("");

  const [mapStatus, setMapStatus] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [hide, setHide] = useState(false);
  const [loanId, setLoanId] = useState("");
  const [lid, setLid] = useState("");
  const [appClientId, setAppClientId] = useState("");
  const TVRPending = React.useRef(null);
  const NEFTData = React.useRef(null);
  const InstantDisbursed = React.useRef(null);
  const NEFTRejected = React.useRef(null);
  const TVRRejected = React.useRef(null);
  const ReHitDrop = React.useRef(null);
  const fileInputRef = useRef(null);
  const [alert, setAlert] = useState(null);
  const [model1, setModel1] = useState(false);
  const [model2, setModel2] = useState(false);
  const [udhaym, setUdhaym] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [width, setWidth] = React.useState(window.innerWidth < 768);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleSubmitSA = () => {
    console.log("dataSA::: ", dataSA);

    if (!staffId) {
      toast.warning("Staff ID is required.");
      return;
    }

    // if (data.sanctionAmount > limitExtend) {
    //   toast.warning("Amount must be higher.");
    //   return;
    // }

    const requestUrl = `${APIURLCOT}/updateSanctionAmount/${data.appClientId}/${limitExtend}/${staffId}`;

    axios
      .get(requestUrl, {
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setShowModalSA(false);
        getClientDetailsMagic(loanId);
        getTvrPendingDetails();
        toast.success("Change amount successfully...");
      })
      .catch((error) => {
        console.log("error", error);
        toast.warning("Invalid...");
      });
  };

  useEffect(() => {
    if (activeTab === "tab1") {
      getTvrPendingDetails();
    }
    if (activeTab === "tab3") {
      getAllNeftSuccessData();
    }
    if (activeTab === "tab2") {
      getInstantDisburse();
    }
    if (activeTab === "tab4") {
      getAllNeftRejectedData();
    }
    if (activeTab === "tab5") {
      getAllRejectedCases();
    }
    if (activeTab === "tab6") {
      getReHitPennyDrop();
    }
  }, [activeTab]);
  function openJSON(data) {
    const jsonString = JSON.parse(JSON.stringify(data)); // formatted JSON
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  }

  const getEqfexDetails = (loanId) => {
    setIsLoader(true);
    axios(`${APIURLCOT}/equifaxdetailca/${loanId}`, {
      method: "GET",
      headers: {
        Authentication: token,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        console.log("::::::123", response.data);
        setIsLoader(false);
        setEqfexData(response.data);
        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };

  const validateGSTIN = async (appId, gstin, jsessionId) => {
    axios
      .post(
        `${APIURLCOT}/cashontap/api/gstin/validate`,
        {
          appId: data.appClientId,
          gstin: gstNumber,
        },
        {
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          }, // ensures cookies are included
        }
      )
      .then((response) => {
        console.log("::::::123", response.data);
        toast.success("Verify Successfully");

        setModel1(false);
        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.error("GSTIN Validation Error:", error);
        toast.error("GSTIN Validation Error");
        setModel1(false);
      });
  };

  const validateUdyam = async (appId, udyam_reg_no, jsessionId) => {
    await axios
      .post(
        `${APIURLCOT}/cashontap/udyam/validate`,
        {
          appId: data.appClientId,
          udyam_reg_no: udhaym,
        },
        {
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        console.log("::::::123", response.data);
        toast.success("Verify Successfully");
        setModel2(false);
        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.error("GSTIN Validation Error:", error);
        toast.error("Udyam Validation Error");
        setModel2(false);
      });
  };

  function getTvrPendingDetails() {
    setIsLoader(true);
    axios
      .request(`${APIURL}/getTvrPendingDetails`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setTvrPending(response?.data);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }

  function getAllNeftSuccessData() {
    setIsLoader(true);
    axios
      .request(`${APIURL}/getAllNeftSuccessData`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setNeftSuccessData(response?.data);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getInstantDisburse() {
    setIsLoader(true);

    axios
      .request(`${APIURLCOT}/BorrowerDetail`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);

        setInstantDisburse(response?.data);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }

  function getAllNeftRejectedData() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getAllNeftRejectedData`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);

        setNeftRejectedData(response?.data);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getAllRejectedCases() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getAllRejectedCases`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);

        setTvrRejected(response?.data);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getReHitPennyDrop() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getReHitPennyDrop`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);

        if (typeof response?.data !== "string") {
          setReHitPennyDrop(response?.data);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getClientDetailsMagic(loanId) {
    setIsLoader(true);
    setHide(false);

    axios
      .request(`${APIURL}/getClientDetailsMagic/${loanId}`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response?.data);
        setMapValue({
          lat: response?.data.clientAddressLat,
          lng: response?.data.clientAddressLong,
        });

        if (response?.data?.creditStatus == 2) {
          setHide(true);
        }
        setIsLoader(false);

        console.log("response::::", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }

  // function getPdDetails(appId) {
  //   setIsLoader(true);
  //   setpdData({});

  //   axios
  //     .request(`${APIURLCOT}/applicationform/${appId}`, {
  //       method: "GET",
  //       headers: {
  //         Authentication: token,

  //         "Content-Type": "application/json",
  //       },
  //     })
  //     .then((response) => {
  //       setpdData(response?.data);
  //       setIsLoader(false);

  //       console.log("response::::", response);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoader(false);
  //     });
  // }

  function getAllDoc(appId) {
    setIsLoader(true);

    axios
      .request(`${APIURLCOT}/allUploadedDocs/${appId}`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setAllDoc(response?.data);
        setIsLoader(false);

        console.log("response::::", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getAddharMessage(pno) {
    setIsLoader(true);

    axios
      .request(`${APIURLCOT}/getMessage/${pno}`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setAddharmesg(response?.data);
        setIsLoader(false);

        console.log("response::::", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function allUploadedDocs() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/allUploadedDocs/${loanId}`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function AccountAggregator() {
    window.open(`${APIURL}/download/${loanId}`);
  }
  function groLocation() {
    setIsLoader(true);

    axios
      .request(`${APIURLCOT}/applicationform/${loanId}`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setShowModal(true);
        setIsLoader(false);

        console.log("response", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }

  function companyLocation() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getGeoLocation/${loanId}`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
      })

      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }

  function epfDetails() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/epfdetails/${loanId}`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleDetailsChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (loadEvent) => {
        const base64String = loadEvent.target.result;
        setClientPhotoBase64(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const employerUploadContact = () => {
    setIsLoader(true);

    const dto = {
      mobileNo: data.mobile,
      appclientid: data.appClientId ? data.appClientId : data.appclientid,
      latitude: "28.6679571",
      longitude: "77.2302148",
      clientPhotoBase64: clientPhotoBase64,
      clientUID: data?.enrollmentid,
      ownerEmail: emailid,
    };
    console.log("data", dto);
    axios
      .request(`${APIURL}/employerUploadContact`, {
        method: "POST",
        data: dto,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setShowUploadModal(false);
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = () => {
    if (approvalStatus == 2) {
      if (password == "ctlA") {
        setShowPasswordModal(false);
        setShowApproveModal(true);
      } else {
        toast.warning("Wrong password");
      }
    }
    if (approvalStatus == 3) {
      if (password == "ctlR") {
        submitData();
        setShowPasswordModal(false);
      } else {
        toast.warning("Wrong password");
      }
    }
    if (approvalStatus == 4) {
      if (password == "ctlF") {
        submitData();
        setShowPasswordModal(false);
      } else {
        toast.warning("Wrong password");
      }
    }
  };

  const handleApprove = (status) => {
    if (status == "new") {
      console.log("status", status);
      setApprove("new");
      submitData(status);
      setPassword("");
      setRemark("");
    }
    if (status == "ignore") {
      pop(status);
      setPassword("");
      setRemark("");
    }
  };

  const submitData = (status) => {
    console.log("approve", approve);
    const appId = localStorage.getItem("userId");
    const dto = {
      actionType: status,
      appclientid: data.appClientId,
      creditstatus: approvalStatus == 4 ? furtherStatus : approvalStatus,
      borrname: data.clientName,
      borrcontactno: data.mobile,
      borrremark: remark,
      approvedby: appId,
    };
    const formData = new FormData();

    for (const key in dto) {
      if (dto.hasOwnProperty(key)) {
        formData.append(key, dto[key]);
      }
    }
    console.log("dto", dto);
    console.log("formData::: ", formData);
    axios
      .request(`${APIURL}/salarytap/saveca`, {
        method: "POST",
        data: formData,
        headers: {
          Authentication: token,

          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
        setShow(false);
        setStaffId("");
        setShowApproveModal(false);
        toast.success(response?.data?.remark);
        setActiveTab("tab2");
        if (response?.data?.remark) {
          setHide(true);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const pop = (status) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block" }}
        title="Are you sure?"
        onConfirm={() => {
          setApprove(status);
          submitData(status);
          setShowApproveModal(false);
          setAlert(null);
        }}
        onCancel={() => {
          setAlert(null);
          setShowApproveModal(false);
        }}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="secondary"
        confirmBtnText="Are you confirm?"
        cancelBtnText="Cancel"
        showCancel
      ></SweetAlert>
    );
  };
  const instantDisburseApprove = (appCientId) => {
    const data = {
      appClientId: appCientId,
      approvedby: 16,
      ownerEmail: emailid,
    };
    setIsLoader(true);

    axios
      .request(`${APIURL}/approvedAndReject`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
        toast.success("Approve successfully.");
        getInstantDisburse();
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const instantDisburseReject = (appCientId) => {
    setIsLoader(true);

    axios
      .request(`${APIURL}/rejectPennyDrop/${appCientId}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
        toast.success("Rejected successfully");
        getInstantDisburse();
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const reHitPennyDropApprove = (id) => {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getReHitPennyDropApproved/${id}`, {
        method: "GET",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
        toast.success("ReHitPennyDrop approve successfully");
        getReHitPennyDrop();
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const reHitPennyDropReject = (id) => {
    setIsLoader(true);

    axios
      .request(`${APIURL}/rejectPennyDrop/${id}`, {
        method: "GET",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
        toast.success("ReHitPennyDrop rejected successfully");
        getReHitPennyDrop();
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  return (
    <div className={width ? "" : "p-3"}>
      <div>
        <div>
          <ul className="nav nav-tabs-CT" id="myTab" role="tablist">
            <li
              className={width ? "nav-item mt-2" : "nav-item"}
              role="presentation"
            >
              <button
                className={`nav-link nav-itm-CT tab-item ${
                  activeTab === "tab1" ? "active" : ""
                }`}
                id="tab1-tab"
                data-bs-toggle="tab"
                data-bs-target="#tab1"
                type="button"
                role="tab"
                aria-controls="tab1"
                aria-selected={activeTab === "tab1"}
                onClick={() => {
                  handleTabClick("tab1");
                  setShow(false);
                }}
              >
                TVR Pending
              </button>
            </li>
            <li
              className={width ? "nav-item mt-2" : "nav-item"}
              role="presentation"
            >
              <button
                className={`nav-link nav-itm-CT tab-item ${
                  activeTab === "tab2" ? "active" : ""
                }`}
                id="tab2-tab"
                data-bs-toggle="tab"
                data-bs-target="#tab2"
                type="button"
                role="tab"
                aria-controls="tab2"
                aria-selected={activeTab === "tab2"}
                onClick={() => {
                  handleTabClick("tab2");
                  setShow(false);
                }}
              >
                TVR Approve
              </button>
            </li>
            {/* <li className="nav-item" role="presentation">
              <button
                className={`nav-link nav-itm-CT tab-item ${
                  activeTab === "tab3" ? "active" : ""
                }`}
                id="tab3-tab"
                data-bs-toggle="tab"
                data-bs-target="#tab3"
                type="button"
                role="tab"
                aria-controls="tab3"
                aria-selected={activeTab === "tab3"}
                onClick={() => handleTabClick("tab3")}
              >
                NEFT Success Data
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link nav-itm-CT tab-item ${
                  activeTab === "tab4" ? "active" : ""
                }`}
                id="tab4-tab"
                data-bs-toggle="tab"
                data-bs-target="#tab4"
                type="button"
                role="tab"
                aria-controls="tab4"
                aria-selected={activeTab === "tab4"}
                onClick={() => handleTabClick("tab4")}
              >
                NEFT Rejected Data
              </button>
            </li> */}
            <li
              className={width ? "nav-item mt-2" : "nav-item"}
              role="presentation"
            >
              <button
                className={`nav-link nav-itm-CT tab-item ${
                  activeTab === "tab5" ? "active" : ""
                }`}
                id="tab5-tab"
                data-bs-toggle="tab"
                data-bs-target="#tab5"
                type="button"
                role="tab"
                aria-controls="tab5"
                aria-selected={activeTab === "tab5"}
                onClick={() => {
                  handleTabClick("tab5");
                  setShow(false);
                }}
              >
                TVR Rejected
              </button>
            </li>
            <li
              className={width ? "nav-item mt-2" : "nav-item"}
              role="presentation"
            >
              <button
                className={`nav-link nav-itm-CT tab-item ${
                  activeTab === "tab6" ? "active" : ""
                }`}
                id="tab6-tab"
                data-bs-toggle="tab"
                data-bs-target="#tab6"
                type="button"
                role="tab"
                aria-controls="tab6"
                aria-selected={activeTab === "tab6"}
                onClick={() => {
                  handleTabClick("tab6");
                  setShow(false);
                }}
              >
                ReHit Penny Drop
              </button>
            </li>
          </ul>
          {!show ? (
            <div className="tab-content" id="myTabContent">
              <div
                className={`tab-pane fade ${
                  activeTab === "tab1" ? "show active" : ""
                }`}
                id="tab1"
                role="tabpanel"
                aria-labelledby="tab1-tab"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3">
                      {showSearch ? (
                        <>
                          <div className="p-3 d-flex justify-content-start mt-3">
                            <button
                              className="btn btn-secondary"
                              style={{ width: "100px" }}
                              onClick={() => {
                                setShowSearch(false);
                              }}
                            >
                              Back
                            </button>
                          </div>
                          <div className="p-3 pt-2">
                            <SearchDetails
                              keyName="appclientId"
                              searchInput={appClientId}
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          {" "}
                          <div className="d-flex ">
                            <DownloadTableExcel
                              filename="TVRPending"
                              sheet="users"
                              currentTableRef={TVRPending.current}
                            >
                              <button
                                className="btn btn-success border"
                                style={{
                                  width: "120px",
                                  backgroundColor: "black ",
                                }}
                              >
                                {" "}
                                Download{" "}
                              </button>
                            </DownloadTableExcel>
                          </div>
                          {isLoader ? (
                            <div className="d-flex justify-content-center">
                              <div
                                className="spinner-border text-success"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            </div>
                          ) : (
                            <div className="table-responsive mt-3">
                              <table
                                className="table table-striped"
                                ref={TVRPending}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Sr. No
                                    </th>
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      App Client Id
                                    </th>
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Client Name
                                    </th>
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Branch Name
                                    </th>
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Mobile No
                                    </th>
                                    {/* <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Loan Type
                                    </th>
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Scheme No.
                                    </th>
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Sanction Amount
                                    </th> */}
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      PD Date
                                    </th>
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      CA Status
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {tvrPending && tvrPending.length > 0 ? (
                                    tvrPending.map((item, i) => (
                                      <tr key={i}>
                                        <td
                                          style={{
                                            textAlign: "center",
                                          }}
                                        >
                                          {i + 1 + pagination.start}
                                        </td>
                                        <td
                                          className="text-nowrap"
                                          style={{
                                            textAlign: "center",
                                            // color: "blue",
                                            // cursor: "pointer",
                                          }}
                                          // onClick={() => {
                                          //   if (item.appClientId) {
                                          //     setAppClientId(item.appClientId);
                                          //     setShowSearch(true);
                                          //   }
                                          // }}
                                        >
                                          {item.appClientId}
                                        </td>
                                        <td
                                          className="text-nowrap"
                                          style={{ textAlign: "left" }}
                                        >
                                          {item.clientName}
                                        </td>
                                        <td
                                          className="text-nowrap"
                                          style={{ textAlign: "left" }}
                                        >
                                          {item?.branchname}
                                        </td>
                                        <td
                                          className="text-nowrap"
                                          style={{ textAlign: "center" }}
                                        >
                                          {item.clientmobileno}
                                        </td>
                                        {/* <td className="text-nowrap">
                                            {item.loanType}
                                          </td>
                                          <td
                                            className="text-nowrap"
                                            style={{ textAlign: "center" }}
                                          >
                                            {item.schemeNo}
                                          </td>
                                          <td
                                            className="text-nowrap"
                                            style={{ textAlign: "center" }}
                                          >
                                            {item.sanctionAmount}
                                          </td> */}
                                        <td
                                          className="text-nowrap"
                                          style={{ textAlign: "center" }}
                                        >
                                          {item.verificationDate}
                                        </td>
                                        <td>
                                          <button
                                            className="btn btn-success"
                                            onClick={() => {
                                              setShow(true);
                                              getAddharMessage(
                                                item?.clientmobileno
                                              );
                                              setLoanId(item?.loanid);
                                              setLoanId(item?.appClientId);
                                              // getPdDetails(item?.appClientId);
                                              getAllDoc(item?.appClientId);
                                              getEqfexDetails(
                                                item?.appClientId
                                              );
                                              getClientDetailsMagic(
                                                item?.appClientId
                                              );
                                            }}
                                          >
                                            View
                                          </button>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan="9"
                                        style={{ textAlign: "center" }}
                                      >
                                        No data available
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          )}
                          {tvrPending && tvrPending.length !== 0 && (
                            <Pagination
                              showPrePage={showPrePage}
                              onPaginationChange={onPaginationChange}
                              total={tvrPending.length}
                            />
                          )}
                        </>
                      )}

                      <table
                        className="table table-striped mt-3 "
                        style={{ display: "none" }}
                      >
                        <thead>
                          <tr>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Sr. No
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              App Client Id
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Client Name
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Mobile No
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Loan Type
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Scheme No.
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Sanction Amount
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Verification Date
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              CA Status
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {tvrPending && tvrPending.length > 0 ? (
                            tvrPending
                              .slice(pagination.start, pagination.end)
                              .map((item, i) => (
                                <tr key={i}>
                                  <td
                                    style={{
                                      textAlign: "center",
                                    }}
                                  >
                                    {i + 1 + pagination.start}
                                  </td>
                                  <td
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    {item.appClientId}
                                  </td>
                                  <td
                                    className="text-nowrap"
                                    style={{ textAlign: "left" }}
                                  >
                                    {item.clientName}
                                  </td>
                                  <td
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    {item.clientmobileno}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.loanType}
                                  </td>
                                  <td
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    {item.schemeNo}
                                  </td>
                                  <td
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    {item.sanctionAmount}
                                  </td>
                                  <td
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    {item.verificationDate}
                                  </td>
                                  <td>-</td>{" "}
                                  {/* Placeholder for future action */}
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="9" style={{ textAlign: "center" }}>
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`tab-pane fade ${
                  activeTab === "tab2" ? "show active" : ""
                }`}
                id="tab2"
                role="tabpanel"
                aria-labelledby="tab2-tab"
              >
                <div className="pt-3">
                  {
                    <div className="card">
                      <div className="p-3">
                        <div className="d-flex">
                          <DownloadTableExcel
                            filename="NEFT Data"
                            sheet="users"
                            currentTableRef={InstantDisbursed.current}
                          >
                            <button
                              className="btn btn-success border"
                              style={{
                                width: "120px",
                                backgroundColor: "black",
                              }}
                            >
                              {" "}
                              Download{" "}
                            </button>
                          </DownloadTableExcel>
                        </div>
                        {isLoader ? (
                          <div className="d-flex justify-content-center">
                            <div
                              className="spinner-border text-success"
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          </div>
                        ) : (
                          <div className="table-responsive mt-3">
                            {/* TVR Approve */}
                            <table
                              className="table table-striped"
                              ref={InstantDisbursed}
                            >
                              <thead>
                                <tr>
                                  <th
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    Sr. No
                                  </th>
                                  <th
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    App Client Id
                                  </th>
                                  <th
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    Client Name
                                  </th>
                                  <th
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    Mobile No
                                  </th>
                                  {/* <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Loan Type
                                    </th>
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Scheme No.
                                    </th>
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Sanction Amount
                                    </th> */}
                                  <th
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    Branch Name
                                  </th>

                                  <th
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    Approve Date
                                  </th>
                                  <th
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    CA Status
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {instantDisburse &&
                                instantDisburse.length > 0 ? (
                                  instantDisburse.map((item, i) => (
                                    <tr key={i}>
                                      {console.log("item::: ", item)}
                                      <td
                                        style={{
                                          textAlign: "center",
                                        }}
                                      >
                                        {i + 1}
                                      </td>
                                      <td
                                        className="text-nowrap"
                                        style={{
                                          textAlign: "center",

                                          cursor: "pointer",
                                        }}
                                        // onClick={() => {
                                        //   if (item.AppClientId) {
                                        //     setAppClientId(item.AppClientId);
                                        //     setShowSearch(true);
                                        //   }
                                        // }}
                                      >
                                        {item.AppClientId}
                                      </td>
                                      <td
                                        className="text-nowrap"
                                        style={{ textAlign: "left" }}
                                      >
                                        {item.BorrName}
                                      </td>
                                      <td
                                        className="text-nowrap"
                                        style={{ textAlign: "center" }}
                                      >
                                        {item.BorrContactNo}
                                      </td>
                                      {/* <td className="text-nowrap">
                                            {item.loanType}
                                          </td>
                                          <td
                                            className="text-nowrap"
                                            style={{ textAlign: "center" }}
                                          >
                                            {item.schemeNo}
                                          </td>
                                          <td
                                            className="text-nowrap"
                                            style={{ textAlign: "center" }}
                                          >
                                            {item.sanctionAmount}
                                          </td> */}
                                      <td
                                        className="text-nowrap"
                                        style={{ textAlign: "center" }}
                                      >
                                        {item.branchName}
                                      </td>
                                      <td
                                        className="text-nowrap"
                                        style={{ textAlign: "center" }}
                                      >
                                        {item.Approveddate}
                                      </td>
                                      <td>
                                        <button
                                          className="btn btn-success"
                                          onClick={() => {
                                            setShow(true);
                                            getAddharMessage(
                                              item?.borrcontactNo
                                            );
                                            setLoanId(item?.LoanId);
                                            setLoanId(item?.AppClientId);
                                            // getPdDetails(item?.AppClientId);
                                            getAllDoc(item?.AppClientId);
                                            getClientDetailsMagic(
                                              item?.AppClientId
                                            );
                                          }}
                                        >
                                          {item.CreditStatus == 2 && "View"}
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="9"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                        {/* {instantDisburse && instantDisburse.length !== 0 && (
                      <Pagination
                        showPrePage={showPrePage}
                        onPaginationChange={onPaginationChange}
                        total={instantDisburse.length}
                      />
                    )} */}
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div
                className={`tab-pane fade ${
                  activeTab === "tab3" ? "show active" : ""
                }`}
                id="tab3"
                role="tabpanel"
                aria-labelledby="tab3-tab"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3">
                      <div className="d-flex ">
                        <DownloadTableExcel
                          filename="NEFT Data"
                          sheet="users"
                          currentTableRef={NEFTData.current}
                        >
                          <button
                            className="btn btn-success border"
                            style={{
                              width: "120px",
                              backgroundColor: "black",
                            }}
                          >
                            {" "}
                            Download{" "}
                          </button>
                        </DownloadTableExcel>
                      </div>
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Sr. No
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Loan Id
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Client Name
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Mobile No
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Done By Id
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Done By Name
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Entry Date
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Status Desc
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {neftSuccessData && neftSuccessData.length > 0 ? (
                                neftSuccessData
                                  .slice(pagination.start, pagination.end)
                                  .map((item, i) => (
                                    <tr key={i}>
                                      <td
                                        style={{
                                          textAlign: "center",
                                        }}
                                      >
                                        {i + 1 + pagination.start}
                                      </td>
                                      <td className="text-nowrap">
                                        {item.loanid}
                                      </td>
                                      <td
                                        className="text-nowrap"
                                        style={{ textAlign: "left" }}
                                      >
                                        {item.clientname}
                                      </td>
                                      <td className="text-nowrap">
                                        {item.clientmobileno}
                                      </td>
                                      <td className="text-nowrap">
                                        {item.doneById}
                                      </td>
                                      <td className="text-nowrap">
                                        {item.doneByName}
                                      </td>
                                      <td className="text-nowrap">
                                        {item?.entryDate}
                                      </td>
                                      <td className="text-nowrap">
                                        {item.statusDesc}
                                      </td>
                                    </tr>
                                  ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="8"
                                    style={{ textAlign: "center" }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                      {neftSuccessData && neftSuccessData.length !== 0 && (
                        <Pagination
                          showPrePage={showPrePage}
                          onPaginationChange={onPaginationChange}
                          total={neftSuccessData.length}
                        />
                      )}
                      <table
                        className="table table-striped mt-3 "
                        style={{ display: "none" }}
                        ref={NEFTData}
                      >
                        <thead>
                          <tr>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Sr. No
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Loan Id
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Client Name
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Mobile No
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Done By Id
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Done By Name
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Entry Date
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Status Desc
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {neftSuccessData?.map((item, i) => (
                            <tr key={i}>
                              <td
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {i + 1}
                              </td>

                              <td className="text-nowrap">{item.loanid}</td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "left" }}
                              >
                                {item.clientname}
                              </td>
                              <td className="text-nowrap">
                                {item.clientmobileno}
                              </td>
                              <td className="text-nowrap">{item.doneById}</td>
                              <td className="text-nowrap">{item.doneByName}</td>
                              <td className="text-nowrap">{item?.entryDate}</td>
                              <td className="text-nowrap">{item.statusDesc}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`tab-pane fade ${
                  activeTab === "tab4" ? "show active" : ""
                }`}
                id="tab4"
                role="tabpanel"
                aria-labelledby="tab4-tab"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3">
                      <div className="d-flex">
                        <DownloadTableExcel
                          filename="NEFT Rejected Data"
                          sheet="users"
                          currentTableRef={NEFTRejected.current}
                        >
                          <button
                            className="btn btn-success border"
                            style={{
                              width: "120px",
                              backgroundColor: "black",
                            }}
                          >
                            {" "}
                            Download{" "}
                          </button>
                        </DownloadTableExcel>
                      </div>
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Sr. No
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Loan Id
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Client Name
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Mobile No
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Done By Id
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Done By Name
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Entry Date
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Status Desc
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {neftRejectedData &&
                              neftRejectedData.length > 0 ? (
                                neftRejectedData
                                  .slice(pagination.start, pagination.end)
                                  .map((item, i) => (
                                    <tr key={i}>
                                      <td
                                        style={{
                                          textAlign: "center",
                                        }}
                                      >
                                        {i + 1 + pagination.start}
                                      </td>
                                      <td className="text-nowrap">
                                        {item.loanid}
                                      </td>
                                      <td
                                        className="text-nowrap"
                                        style={{ textAlign: "left" }}
                                      >
                                        {item.clientname}
                                      </td>
                                      <td className="text-nowrap">
                                        {item.clientmobileno}
                                      </td>
                                      <td className="text-nowrap">
                                        {item.doneById}
                                      </td>
                                      <td className="text-nowrap">
                                        {item.doneByName}
                                      </td>
                                      <td className="text-nowrap">
                                        {item?.entryDate}
                                      </td>
                                      <td className="text-nowrap">
                                        {item.statusDesc}
                                      </td>
                                    </tr>
                                  ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="8"
                                    style={{ textAlign: "center" }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                      {neftRejectedData && neftRejectedData.length !== 0 && (
                        <Pagination
                          showPrePage={showPrePage}
                          onPaginationChange={onPaginationChange}
                          total={neftRejectedData.length}
                        />
                      )}
                      <table
                        className="table table-striped mt-3 "
                        style={{ display: "none" }}
                        ref={NEFTRejected}
                      >
                        <thead>
                          <tr>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Sr. No
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Loan Id
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Client Name
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Mobile No
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Done By Id
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Done By Name
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Entry Date
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Status Desc
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {neftRejectedData?.map((item, i) => (
                            <tr key={i}>
                              <td
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {i + 1}
                              </td>

                              <td className="text-nowrap">{item.loanid}</td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "left" }}
                              >
                                {item.clientname}
                              </td>
                              <td className="text-nowrap">
                                {item.clientmobileno}
                              </td>
                              <td className="text-nowrap">{item.doneById}</td>
                              <td className="text-nowrap">{item.doneByName}</td>
                              <td className="text-nowrap">{item?.entryDate}</td>
                              <td className="text-nowrap">{item.statusDesc}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`tab-pane fade ${
                  activeTab === "tab5" ? "show active" : ""
                }`}
                id="tab5"
                role="tabpanel"
                aria-labelledby="tab5-tab"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3">
                      <div className="d-flex ">
                        <DownloadTableExcel
                          filename="TVR Rejected"
                          sheet="users"
                          currentTableRef={TVRRejected.current}
                        >
                          <button
                            className="btn btn-success border"
                            style={{
                              width: "120px",
                              backgroundColor: "black",
                            }}
                          >
                            {" "}
                            Download{" "}
                          </button>
                        </DownloadTableExcel>
                      </div>
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          <table
                            className="table table-striped "
                            ref={TVRRejected}
                          >
                            <thead>
                              <tr>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Sr. No
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  App Client Id
                                </th>
                                {/* <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Loan Id
                              </th> */}
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Client Name
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Mobile No
                                </th>
                                {/* <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Loan Type
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Scheme No.
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Sanction Amount
                              </th> */}
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Branch Name
                                </th>
                                {/* <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Cluster
                              </th> */}
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Rejected Date
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {tvrRejected && tvrRejected.length > 0 ? (
                                tvrRejected.map((item, i) => (
                                  <tr key={i}>
                                    <td
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      {i + 1 + pagination.start}
                                    </td>
                                    <td className="text-nowrap">
                                      {item.appClientId}
                                    </td>
                                    {/* <td className="text-nowrap">{item.loanid}</td> */}
                                    <td
                                      className="text-nowrap"
                                      style={{ textAlign: "left" }}
                                    >
                                      {item.clientName}
                                    </td>
                                    <td className="text-nowrap">
                                      {item.clientmobileno}
                                    </td>
                                    {/* <td className="text-nowrap">
                                    {item.loanType}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.schemeNo}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.sanctionAmount}
                                  </td> */}
                                    <td className="text-nowrap">
                                      {item.branchname}
                                    </td>
                                    {/* <td className="text-nowrap">
                                    {item.cluster}
                                  </td> */}
                                    <td className="text-nowrap">
                                      {item.verificationDate}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="11"
                                    style={{ textAlign: "center" }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                      {tvrRejected && tvrRejected.length !== 0 && (
                        <Pagination
                          showPrePage={showPrePage}
                          onPaginationChange={onPaginationChange}
                          total={tvrRejected.length}
                        />
                      )}

                      <table
                        className="table table-striped mt-3 "
                        style={{ display: "none" }}
                        ref={TVRRejected}
                      >
                        <thead>
                          <tr>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Sr. No
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              App Client Id
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Loan Id
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Client Name
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Mobile No
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Loan Type
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Scheme No.
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Sanction Amount
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Branch Name
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Cluster
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Rejected Date
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {tvrRejected?.map((item, i) => (
                            <tr key={i}>
                              <td
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {i + 1}
                              </td>

                              <td className="text-nowrap">
                                {item.appClientId}
                              </td>
                              <td className="text-nowrap">{item.loanid}</td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "left" }}
                              >
                                {item.clientName}
                              </td>
                              <td className="text-nowrap">
                                {item.clientmobileno}
                              </td>
                              <td className="text-nowrap">{item.loanType}</td>
                              <td className="text-nowrap">{item.schemeNo}</td>
                              <td className="text-nowrap">
                                {item.sanctionAmount}
                              </td>
                              <td className="text-nowrap">{item.branchname}</td>
                              <td className="text-nowrap">{item.cluster}</td>
                              <td className="text-nowrap">
                                {item.verificationDate}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`tab-pane fade ${
                  activeTab === "tab6" ? "show active" : ""
                }`}
                id="tab6"
                role="tabpanel"
                aria-labelledby="tab6-tab"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3">
                      <div className="d-flex">
                        <DownloadTableExcel
                          filename="ReHit Penny Drop"
                          sheet="users"
                          currentTableRef={ReHitDrop.current}
                        >
                          <button
                            className="btn btn-success border"
                            style={{
                              width: "120px",
                              backgroundColor: "black",
                            }}
                          >
                            {" "}
                            Download{" "}
                          </button>
                        </DownloadTableExcel>
                      </div>
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          <table
                            className="table table-striped "
                            ref={ReHitDrop}
                          >
                            <thead>
                              <tr>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Sr. No
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  App Client Id
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Loan Id
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Client Name
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Mobile No
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Sanction Amount
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Branch Name
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  IFSC Code
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Bank Branch
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Entry Date
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Status
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Approve
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Reject
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {reHitPennyDrop && reHitPennyDrop.length > 0 ? (
                                reHitPennyDrop.map((item, i) => (
                                  <tr key={i}>
                                    <td
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      {i + 1 + pagination.start}
                                    </td>
                                    <td className="text-nowrap text-center">
                                      {item.appclientid}
                                    </td>
                                    <td className="text-nowrap text-center">
                                      {item.loanid}
                                    </td>
                                    <td
                                      className="text-nowrap"
                                      style={{ textAlign: "left" }}
                                    >
                                      {item.clientname}
                                    </td>
                                    <td className="text-nowrap text-center">
                                      {item.clientmobileno}
                                    </td>
                                    <td className="text-nowrap text-center">
                                      {item.sanctionAmount}
                                    </td>
                                    <td className="text-nowrap">
                                      {item.branchName}
                                    </td>
                                    <td className="text-nowrap text-center">
                                      {item.clientBankIfsc}
                                    </td>
                                    <td className="text-nowrap text-center">
                                      {item.clientAccountNo}
                                    </td>
                                    <td className="text-nowrap text-center">
                                      {item?.entrydate}
                                    </td>
                                    <td className="text-nowrap">
                                      {item.status}
                                    </td>
                                    <td className="text-nowrap">
                                      <button
                                        className="btn btn-success"
                                        onClick={() =>
                                          reHitPennyDropApprove(item.loanid)
                                        }
                                      >
                                        {isLoader ? (
                                          <div
                                            className="spinner-border text-success"
                                            role="status"
                                          >
                                            <span className="sr-only">
                                              Loading...
                                            </span>
                                          </div>
                                        ) : (
                                          "Approve"
                                        )}
                                      </button>
                                    </td>
                                    <td className="text-nowrap">
                                      <button
                                        className="btn btn-danger"
                                        onClick={() =>
                                          reHitPennyDropReject(item.loanid)
                                        }
                                      >
                                        {isLoader ? (
                                          <div
                                            className="spinner-border text-danger"
                                            role="status"
                                          >
                                            <span className="sr-only">
                                              Loading...
                                            </span>
                                          </div>
                                        ) : (
                                          "Reject"
                                        )}
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="13"
                                    style={{ textAlign: "center" }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                      {/* {reHitPennyDrop && reHitPennyDrop.length !== 0 && (
                      <Pagination
                        showPrePage={showPrePage}
                        onPaginationChange={onPaginationChange}
                        total={reHitPennyDrop.length}
                      />
                    )} */}
                      <table
                        className="table table-striped mt-3 "
                        style={{ display: "none" }}
                        // ref={ReHitDrop}
                      >
                        <thead>
                          <tr>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Sr. No
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              App Client Id
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Loan Id
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Client Name
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Mobile No
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Sanction Amount
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Branch Name
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              IFSC Code
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Bank Branch
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Entry Date
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Status
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Approve
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Reject
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {reHitPennyDrop?.map((item, i) => (
                            <tr key={i}>
                              <td
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {i + 1}
                              </td>

                              <td
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                {item.appclientid}
                              </td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                {item.loanid}
                              </td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "left" }}
                              >
                                {item.clientname}
                              </td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                {item.clientmobileno}
                              </td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                {item.sanctionAmount}
                              </td>
                              <td className="text-nowrap">{item.branchName}</td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                {item.clientBankIfsc}
                              </td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                {item.clientAccountNo}
                              </td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                {item?.entrydate}
                              </td>
                              <td className="text-nowrap">{item.status}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {alert}
              <div className="card">
                <div className="p-3">
                  <div className="d-flex justify-content-end">
                    <div>
                      <button
                        className="btn btn-success"
                        onClick={() => {
                          setShow(false);
                          setStaffId("");
                        }}
                        style={{
                          width: "100px",
                          color: "black",
                          background: "transparent",
                          border: "0px",
                          textDecoration: "underline",
                          fontSize: "18px",
                        }}
                      >
                        Back
                      </button>
                    </div>
                  </div>
                  <div className="">
                    <ul className="nav nav-tabs-CT" id="myTab" role="tablist">
                      {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link nav-itm-CT tab-link-ct `}
                                role="tab"
                              >
                                <a
                                  href={`${APIURL}/allUploadedDocs/${loanId}`}
                                  style={{ textDecoration: "none" }}
                                >
                                  ID Photo
                                </a>
                              </button>
                            </li> */}
                      {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link nav-itm-CT tab-link-ct `}
                                role="tab"
                              >
                                <a href="#" style={{ textDecoration: "none" }}>
                                  Self Photo
                                </a>
                              </button>
                            </li> */}
                      {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link tab-link `}
                                role="tab"
                              >
                                <a
                                  href={`${APIURL}/epfdetails/${loanId}`}
                                  style={{ textDecoration: "none" }}
                                >
                                  EPF DETAILS
                                </a>
                              </button>
                            </li> */}
                      {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link nav-itm-CT tab-link-ct `}
                                role="tab"
                              >
                                <a href="#" style={{ textDecoration: "none" }}>
                                  PAN CARD
                                </a>
                              </button>
                            </li> */}
                      {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link tab-link `}
                                role="tab"
                              >
                                <a
                                  href={`${APIURL}/download/${loanId}`}
                                  style={{ textDecoration: "none" }}
                                >
                                  ACCOUNT AGGREGATOR
                                </a>
                              </button> 
                            </li>*/}
                      {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link nav-itm-CT tab-link-ct `}
                                role="tab"
                              >
                                <a href="#" style={{ textDecoration: "none" }}>
                                  DEVICE DETAILS
                                </a>
                              </button>
                            </li> */}
                      {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link tab-link `}
                                role="tab"
                                onClick={companyLocation}
                                style={{ textDecoration: "none" }}
                              >
                                COMPANY LOCATION
                              </button>
                            </li> */}

                      {allDoc?.map((list, key) => (
                        <li className="nav-item" role="presentation" key={key}>
                          <div
                            className="card ml-2 mt-2 shadow-sm d-flex flex-column justify-content-between"
                            style={{
                              width: "160px",
                              height: "200px",
                              borderRadius: "8px",
                            }}
                          >
                            <img
                              className="card-img-top p-2"
                              src={list.doclink}
                              alt="Document Preview"
                              style={{
                                height: "150px",
                                width: "100%",
                                objectFit: "contain",
                                borderTopLeftRadius: "8px",
                                borderTopRightRadius: "8px",
                                backgroundColor: "#f8f9fa",
                              }}
                            />
                            <div className="card-body p-2 text-center d-flex align-items-end">
                              <button
                                className="btn  btn-sm w-100"
                                role="tab"
                                onClick={() =>
                                  // window.open(list.doclink, "_blank")
                                  {
                                    setShowModalImg(true);
                                    setImgUrl(list);
                                  }
                                }
                                style={{
                                  textDecoration: "none",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color: "blue",
                                }}
                              >
                                {list.doctype.replace(/_/g, " ").toUpperCase()}
                              </button>
                            </div>
                          </div>
                        </li>
                      ))}

                      {/* <li className="nav-item mt-3 ml-2" role="presentation">
                        <div class="card">
                          <button
                            className={`nav-link nav-itm-CT tab-link-ct `}
                            role="tab"
                            style={{ textDecoration: "none" }}
                            onClick={groLocation}
                          >
                            GEOLOCATION
                          </button>
                        </div>
                      </li> */}

                      {/* {pdDoc.map((list, key) => (
                              <li className="nav-item" role="presentation">
                                <button
                                  className={`nav-link nav-itm-CT tab-link-ct `}
                                  role="tab"
                                  style={{ textDecoration: "none" }}
                                  onClick={() =>
                                    window.open(list.url, "_blank")
                                  }
                                >
                                  {list.doctype}
                                </button>
                              </li>
                            ))} */}
                    </ul>
                  </div>

                  <Modal
                    size="lg"
                    show={showModal}
                    onHide={handleModalClose}
                    style={{ background: "#ffffffc4" }}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>GEOLOCATION</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <MapContainer data={mapValue} status={mapStatus} />
                    </Modal.Body>
                  </Modal>

                  <div
                    style={{
                      fontFamily: "PostGrotesk",
                      borderRadius: "10px",
                    }}
                  >
                    <div className="row mt-3">
                      <div className="col-lg-4 col-md-4 col-sm-12">
                        <div
                          className=""
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">Loan Details</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                              {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Branch ID
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Loan Id
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.loanid}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Client Id
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.enrollmentid}
                                      </th>
                                    </tr> */}
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    padding: "10px",
                                  }}
                                >
                                  Sanction Amount
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                    padding: "10px",
                                    display: "flex",
                                    justifyContent: "space-between", // Pushes text left & button right
                                    alignItems: "center", // Vertically aligns content
                                    gap: "10px", // Adds spacing between text & button
                                  }}
                                >
                                  <span>{data?.sanctionAmount}</span>
                                  <button
                                    onClick={() => {
                                      setShowModalSA(true);
                                      setLimitExtend(data.sanctionAmount);
                                    }}
                                    style={{
                                      backgroundColor: "black", // Green color
                                      color: "white",
                                      border: "none",
                                      padding: "8px 16px",
                                      fontSize: "14px",
                                      cursor: "pointer",
                                      borderRadius: "4px",
                                      transition: "0.3s",
                                    }}
                                  >
                                    Change
                                  </button>
                                </th>
                              </tr>

                              {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Scheme No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.schemeNo}
                                      </th>
                                    </tr> */}
                              {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Product
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.product}
                                      </th>
                                    </tr> */}
                              {/* <tr>
                                      <th style={{ border: "none" }}>Period</th>
                                      <th style={{ border: "none" }}>
                                        {data?.period}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>EMI</th>
                                      <th style={{ border: "none" }}>
                                        {data?.emi}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Equifax 360
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.score}
                                      </th>
                                    </tr> */}
                              <tr>
                                <th style={{ border: "none" }}>Pincode</th>
                                <th style={{ border: "none" }}>
                                  {data.pincode}
                                </th>
                              </tr>
                              {/* <tr>
                                      <th style={{ border: "none" }}>E-Mail</th>
                                      <th style={{ border: "none" }}>
                                        {data.emailid}
                                      </th>
                                    </tr> */}
                              {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Date Of Exit
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.dateofexit}
                                      </th>
                                    </tr> */}

                              <tr>
                                <th style={{ border: "none" }}>Entry Date</th>
                                <th style={{ border: "none" }}>
                                  {moment(data?.entryDate).format(
                                    "DD/MM/YYYY hh:mm:ss A"
                                  )}
                                </th>
                              </tr>
                              {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Account Number
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.clientaccountno}
                                      </th>
                                    </tr> */}
                              <tr></tr>

                              <tr>
                                <th style={{ border: "none" }}>Branch Name</th>
                                <th style={{ border: "none" }}>
                                  {data.branchName}
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>
                                  Client Add Latitude
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.clientAddressLat}
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>
                                  Client Add Longitude
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.clientAddressLong}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Branch Latitude
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.branchLat}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Branch Longitude
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.branchLong}
                                </th>
                              </tr>
                              {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Brnach Type
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.branchType}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Client Dist
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.clientDist}
                                      </th>
                                    </tr> */}
                              <tr>
                                <th style={{ border: "none" }}>
                                  Office Pincode
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.officeaddress}
                                </th>
                              </tr>
                              {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Client Account No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.clientaccountno}
                                      </th>
                                    </tr> */}

                              <tr>
                                <th style={{ border: "none" }}>
                                  Client Distance
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.clientDist || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>GEO LOCATION</th>
                                <th style={{ border: "none" }}>
                                  <button
                                    className="btn btn-primary"
                                    role="tab"
                                    style={{ textDecoration: "none" }}
                                    onClick={groLocation}
                                  >
                                    GEOLOCATION
                                  </button>
                                </th>
                              </tr>
                            </tbody>
                          </table>
                          <div className="mt-3">
                            <span className="fw-bold ms-2">
                              Borrower KYC Address :-
                            </span>
                            <br />
                            <div className="ms-3" style={{ fontSize: "18px" }}>
                              <span>
                                {data.clienthouseno && (
                                  <span>{data.clienthouseno}, </span>
                                )}
                                {data.clientstreet && (
                                  <span>{data.clientstreet}, </span>
                                )}
                                {data.clientlocality && (
                                  <span>{data.clientlocality}, </span>
                                )}
                                {data.clientlandmark && (
                                  <span>{data.clientlandmark}, </span>
                                )}
                                {data.clienttown && (
                                  <span>{data.clienttown}, </span>
                                )}
                                {data.clientpostoffice && (
                                  <span>{data.clientpostoffice}, </span>
                                )}
                                {data.clientsubdistrict && (
                                  <span>{data.clientsubdistrict}, </span>
                                )}
                                {data.clientdistrict && (
                                  <span>{data.clientdistrict}, </span>
                                )}
                                {data.clientstate && (
                                  <span>{data.clientstate}, </span>
                                )}
                                {data.clientpincode && (
                                  <span>{data.clientpincode}</span>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          className="mt-2"
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">Account Aggregator</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ border: "none" }}>Account No</th>
                                <th style={{ border: "none" }}>
                                  {data.accountno || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Account Aggregator Name
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.accountAggregatorName || "-"}
                                </th>
                              </tr>
                              {/* <tr>
                                      <th style={{ border: "none" }}>
                                        First Month Salary
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.firstMonthSalary || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Second Month Salary
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.secondMonthSalary || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Third Month Salary
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.thirdMonthSalary || "-"}
                                      </th>
                                    </tr> */}
                              <tr>
                                <th style={{ border: "none" }}>
                                  Average Eod Balance
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.averageEodBalance || "-"}
                                </th>
                              </tr>{" "}
                              <tr>
                                <th style={{ border: "none" }}>
                                  Diff Transaction
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.diffTransaction || "-"}
                                </th>
                              </tr>{" "}
                              <tr>
                                <th style={{ border: "none" }}>
                                  Date Of Joining
                                </th>
                                <th style={{ border: "none" }}>
                                  {moment(data.dateOfJoining).format(
                                    "DD/MM/YYYY hh:mm:ss A"
                                  )}
                                </th>
                              </tr>{" "}
                              <tr>
                                <th style={{ border: "none" }}>
                                  Total No Of Credit Transactions
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.totalNoOfCreditTransactions || "-"}
                                </th>
                              </tr>{" "}
                              <tr>
                                <th style={{ border: "none" }}>
                                  Total No Of Debit Transactions
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.totalNoOfDebitTransactions || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Account Aggregator Response
                                </th>
                                <th style={{ border: "none" }}>
                                  <button
                                    className="btn btn-outline-primary"
                                    onClick={() =>
                                      openJSON(data.responsejson || {})
                                    }
                                  >
                                    Click
                                  </button>
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Account Aggregator Excel
                                </th>
                                <th style={{ border: "none" }}>
                                  <a
                                    href={`https://tap.capitaltrust.in:8083/cashontap/s3pathExcelDownload/${data.appClientId}`}
                                  >
                                    Download
                                  </a>
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">Equifax Data</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Mobile Number
                                </th>
                                <th style={{ border: "none" }}>
                                  {eqfexData[0]?.mobNumber || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Score
                                </th>
                                <th style={{ border: "none" }}>
                                  {eqfexData[0]?.score || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Entry Date
                                </th>
                                <th style={{ border: "none" }}>
                                  {eqfexData[0]?.entrydate || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Response
                                </th>
                                <th style={{ border: "none" }}>
                                  <button
                                    className="btn btn-primary"
                                    style={{ width: "80px" }}
                                    onClick={() =>
                                      openJSON(eqfexData[0]?.response)
                                    }
                                  >
                                    JSON
                                  </button>
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Live Loan
                                </th>
                                <th style={{ border: "none" }}>
                                  {eqfexData[0]?.liveLoan || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Overdue
                                </th>
                                <th style={{ border: "none" }}>
                                  {JSON.stringify(eqfexData[0]?.overdue) || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Write-off Amount
                                </th>
                                <th style={{ border: "none" }}>
                                  {eqfexData[0]?.writeofamount || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Six Month Delay
                                </th>
                                <th style={{ border: "none" }}>
                                  {JSON.stringify(
                                    eqfexData[0]?.sixmonthdelay
                                  ) || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  NTC
                                </th>
                                <th style={{ border: "none" }}>
                                  {JSON.stringify(eqfexData[0]?.ntc) || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Overdue Amount
                                </th>
                                <th style={{ border: "none" }}>
                                  {JSON.stringify(
                                    eqfexData[0]?.overdueamount
                                  ) || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Old Customer
                                </th>
                                <th style={{ border: "none" }}>
                                  {eqfexData[0]?.oldCustomer || "-"}
                                </th>
                              </tr>

                              {eqfexData &&
                                eqfexData.map((item, i) => (
                                  <tr>
                                    <th
                                      style={{
                                        border: "none",
                                      }}
                                    >
                                      {item.docName}
                                    </th>
                                    <th style={{ border: "none" }}>
                                      <a href={item.docUrl}>{item.docName}</a>
                                    </th>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-12">
                        <div
                          className=""
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">User Profile</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Name
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  {data.name || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Mobile No
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  {data.mobile || "-"}
                                </th>
                              </tr>

                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Addhar Number
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  {data.kycAadhaarNumber || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Pan Number
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  {data.pannumber || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  Pin Code
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  {data.pincode || "-"}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">Borrower Details</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ border: "none" }}>
                                  App Client Id
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.appClientId
                                    ? data.appClientId
                                    : data.appclientid}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>Name</th>
                                <th style={{ border: "none" }}>
                                  {data.name || data.clientname}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>Gender</th>
                                <th style={{ border: "none" }}>
                                  {data.gender === "M"
                                    ? "Male"
                                    : data.gender === "F"
                                    ? "Female"
                                    : ""}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>C/O</th>
                                <th style={{ border: "none" }}>
                                  {data.careOf}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>Relation</th>
                                <th style={{ border: "none" }}>
                                  {data.relation === "M"
                                    ? "Mother"
                                    : data.relation === "F"
                                    ? "Father"
                                    : data.relation === "H"
                                    ? "Husband"
                                    : data.relation === "W"
                                    ? "Wife"
                                    : ""}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Date Of Birth
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.dateOfBirth
                                    ? moment(data.dateOfBirth).format(
                                        "DD-MM-YYYY"
                                      )
                                    : ""}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>Mobile</th>
                                <th style={{ border: "none" }}>
                                  {data.mobile}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  KYC Aadhar Card
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.kycAadhaarNumber || data.kycNumber}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>Ref Name</th>
                                <th style={{ border: "none" }}>
                                  {data.refName}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>Ref Mobile</th>
                                <th style={{ border: "none" }}>
                                  {data.refMobile}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  certificate Name
                                </th>
                                <th style={{ border: "none" }}>
                                  {data?.certificateName}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Certificate Number
                                </th>
                                <th style={{ border: "none" }}>
                                  {data?.certificateNumber}
                                  <button
                                    className="btn btn-success"
                                    onClick={() => {
                                      setModel1(true);
                                      setGstNumber(data?.certificateNumber);
                                    }}
                                  >
                                    Verify
                                  </button>
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>QrName</th>
                                <th style={{ border: "none" }}>
                                  {data?.qrName}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  App Upload UpiId
                                </th>
                                <th style={{ border: "none" }}>
                                  {data?.appUploadUpiId}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Business Place
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.businessPlace}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  No Of Years Current Location
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.noOfYerasCurrentLocation}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Overall No Of Years
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.overallNoOfYears}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Pan Link With Aadhar
                                </th>
                                <th style={{ border: "none" }}>
                                  <span>({addharmesg || "-"})</span>
                                </th>
                              </tr>
                              {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Employee Type
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.employeeType === 1
                                          ? "Salaried Employee"
                                          : data.employeeType === 2
                                          ? "Self Employee"
                                          : ""}
                                      </th>
                                    </tr> */}
                              {data.employeeType === 2 && (
                                <tr>
                                  <th style={{ border: "none" }}>
                                    Average Eod Balance
                                  </th>
                                  <th style={{ border: "none" }}>
                                    {data.averageEodBalance}
                                  </th>
                                </tr>
                              )}
                              {data.employeeType === 2 && (
                                <tr>
                                  <th style={{ border: "none" }}>
                                    Total No of Credit
                                  </th>
                                  <th style={{ border: "none" }}>
                                    {data.totalNoOfCreditTransactions}
                                  </th>
                                </tr>
                              )}
                              {data.employeeType === 2 && (
                                <tr>
                                  <th style={{ border: "none" }}>
                                    Total No of Debit
                                  </th>
                                  <th style={{ border: "none" }}>
                                    {data.totalNoOfDebitTransactions}
                                  </th>
                                </tr>
                              )}
                              {/* {data.employeeType === 1 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          Employee Name
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {data.employerName}
                                        </th>
                                      </tr>
                                    )}
                                    {data.employeeType === 1 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          Date Of Joining
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {moment(data.dateOfJoining).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </th>
                                      </tr>
                                    )} */}
                            </tbody>
                          </table>
                        </div>

                        <div
                          className="mt-2"
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">Banking</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  UPI Nach Account No
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  {data.clientaccountno || "-"}
                                </th>
                              </tr>

                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  AA account No
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  {data.accountno || "-"}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">UPI</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  Nach UPI ID
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  {data.upiId || "-"}
                                </th>
                              </tr>

                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  QR Code ID
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  {pdData?.appUploadUpiId || "-"}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div
                          className="mt-2"
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">Name</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  ⁠ ⁠⁠AA Name
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  {data.accountAggregatorName || "-"}
                                </th>
                              </tr>

                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  ⁠⁠UPI Nach Account Name
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  {data.name || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  ⁠⁠QR code name
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  {pdData.qrName || "-"}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        {/* <div
                          className="mt-2"
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">Moile</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                              

                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  UPI Mobile No
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  {pdData?.upiMobileNo || "-"}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div> */}
                      </div>

                      <div className="col-lg-4 col-md-4 col-sm-12">
                        {/* <div
                          className=""
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">PD Details</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                            

                              <tr>
                                <th style={{ border: "none" }}>Entry Date</th>
                                <th style={{ border: "none" }}>
                                  {moment(pdData?.entryDate).format(
                                    "DD/MM/YYYY hh:mm:ss A"
                                  )}
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>PD By</th>
                                <th style={{ border: "none" }}>
                                  {pdData.staffName} ({pdData.staffId})
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>
                                  Neighbour Name
                                </th>
                                <th style={{ border: "none" }}>
                                  {pdData.neighbourName}
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>
                                  Neighbour Mobile
                                </th>
                                <th style={{ border: "none" }}>
                                  {pdData.neighbourMobileNo}
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>
                                  Neighbour Feedback
                                </th>
                                <th style={{ border: "none" }}>
                                  {pdData.neighbourFeedback}
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>
                                  Nature of Business
                                </th>
                                <th style={{ border: "none" }}>
                                  {pdData.natureOfBusiness}
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>
                                  Business Place
                                </th>
                                <th style={{ border: "none" }}>
                                  {pdData.businessPlace || "N/A"}
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>
                                  No. of Years at Current Location
                                </th>
                                <th style={{ border: "none" }}>
                                  {pdData.noOfYearsCurrentLocation}
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>
                                  Overall No. of Years
                                </th>
                                <th style={{ border: "none" }}>
                                  {pdData.overallNoOfYears}
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>Remark</th>
                                <th style={{ border: "none" }}>
                                  {pdData.remark}
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>Latitude</th>
                                <th style={{ border: "none" }}>
                                  {pdData.latitude}
                                </th>
                              </tr>

                              <tr>
                                <th style={{ border: "none" }}>Longitude</th>
                                <th style={{ border: "none" }}>
                                  {pdData.longitude}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div> */}
                        <div
                          className="mt-2"
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">Nach Details</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ border: "none" }}>UPI Id</th>
                                <th style={{ border: "none" }}>
                                  {data.upiId || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Upload Status
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.nachUploadStatus || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Emandate Bank Name
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.emandateBankName || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Emandate Client Name
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.emandateClientName || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>IFSC</th>
                                <th style={{ border: "none" }}>
                                  {data.accountIfsc || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Customer A/C No
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.customerAccountNumber || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  A/C Holder Name
                                </th>
                                <th style={{ border: "none" }}>
                                  {data.accountHolderName || "-"}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">Bank Details</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ border: "none" }}>Bank Name</th>
                                <th style={{ border: "none" }}>
                                  {data.bankname || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>A/C No</th>
                                <th style={{ border: "none" }}>
                                  {data.clientaccountno || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>Bank Branch</th>
                                <th style={{ border: "none" }}>
                                  {data.bankBranch || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>IFSC Code</th>
                                <th style={{ border: "none" }}>
                                  {data.ifscCode || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>Cheque</th>
                                <th style={{ border: "none" }}>
                                  {data.cheque || "-"}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div
                          className="mt-2"
                          style={{
                            borderRadius: "0px",
                            border: "2px solid #CACACA",
                          }}
                        >
                          <h5 className="p-2">Bank Details</h5>
                          <hr />
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ border: "none" }}>
                                  GST Certificate Number
                                </th>
                                <th style={{ border: "none" }}>
                                  {data?.certificateNumber}
                                  <button
                                    className="btn btn-success"
                                    onClick={() => {
                                      setModel1(true);
                                      setGstNumber(data?.certificateNumber);
                                    }}
                                  >
                                    Verify
                                  </button>
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>
                                  Udyam Certificate Number
                                </th>
                                <th style={{ border: "none" }}>
                                  {data?.udyamCertificate}
                                  <button
                                    className="btn btn-success"
                                    onClick={() => {
                                      setModel2(true);
                                      setUdhaym(data?.udyamCertificate);
                                    }}
                                  >
                                    Verify
                                  </button>
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      {/* <div className="col-lg-4 col-md-4 col-sm-12">
                              <div
                                className=""
                                style={{
                                  borderRadius: "0px",
                                  border: "2px solid #CACACA",
                                }}
                              >
                                <h5 className="p-2">Reference Details</h5>
                                <hr />
                                <table
                                  className="table table-striped m-0"
                                  style={{
                                    tableLayout: "fixed",
                                    border: "none",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Client Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.clientName || data.clientname}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Account Aggregator Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.accountAggregatorName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Current Organisation Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.currentOrganisationName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        EPF Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.epfName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Sim Owner Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.simOwnerName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        PAN Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.panName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        First Reference Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.firstRefName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        First Reference Relation
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.firstRefRelation}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        First Reference Contact No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.firstRefMobile}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Friend Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.friendName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Friend Contact No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.friendMobileno}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Friend No Of Years
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.friendNoOfYears}
                                      </th>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div> */}
                    </div>

                    <div className="mt-5 d-flex justify-content-center">
                      <table className="table table-bordered w-100 w-md-75 border">
                        <tbody>
                          {!hide && (
                            <>
                              <tr className="border">
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    border: "none",
                                  }}
                                >
                                  Approval Status
                                </td>
                                <td
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  <div className="row mt-2">
                                    <div className="col-lg-6 col-md-6 gap-2 col-sm-12 d-flex align-items-center">
                                      <input
                                        type="radio"
                                        name="shipSpeed"
                                        value="2"
                                        checked={approvalStatus === "2"}
                                        onChange={(e) =>
                                          setApprovalStatus(e.target.value)
                                        }
                                        style={{
                                          height: "18px",
                                          width: "18px",
                                        }}
                                      />
                                      <label className="m-0">Approve</label>
                                    </div>
                                    <div className="col-lg-6 col-md-6 gap-2 col-sm-12 d-flex align-items-center">
                                      <input
                                        type="radio"
                                        name="shipSpeed"
                                        value="3"
                                        checked={approvalStatus === "3"}
                                        onChange={(e) =>
                                          setApprovalStatus(e.target.value)
                                        }
                                        style={{
                                          height: "18px",
                                          width: "18px",
                                        }}
                                      />
                                      <label className="m-0">Reject</label>
                                    </div>
                                    <div className="col-lg-6 col-md-6 gap-2 col-sm-12 d-flex align-items-center mt-2">
                                      <input
                                        type="radio"
                                        name="shipSpeed"
                                        value="4"
                                        checked={approvalStatus === "4"}
                                        onChange={(e) =>
                                          setApprovalStatus(e.target.value)
                                        }
                                        style={{
                                          height: "18px",
                                          width: "18px",
                                        }}
                                      />
                                      <label className="m-0">
                                        Further Action
                                      </label>
                                    </div>
                                  </div>

                                  {approvalStatus == 4 && (
                                    <>
                                      <hr />
                                      <div className="row mt-3">
                                        <div className="col-lg-6 col-md-6 gap-2 col-sm-12 d-flex align-items-center">
                                          <input
                                            type="radio"
                                            name="shipSpeed1"
                                            value="5"
                                            checked={furtherStatus === "5"}
                                            onChange={(e) =>
                                              setFurtherStatus(e.target.value)
                                            }
                                            style={{
                                              height: "18px",
                                              width: "18px",
                                            }}
                                          />
                                          <label className="m-0">Natch</label>
                                        </div>
                                        <div className="col-lg-6 col-md-6 gap-2 col-sm-12 d-flex align-items-center ">
                                          <input
                                            type="radio"
                                            name="shipSpeed1"
                                            value="6"
                                            checked={furtherStatus === "6"}
                                            onChange={(e) =>
                                              setFurtherStatus(e.target.value)
                                            }
                                            style={{
                                              height: "18px",
                                              width: "18px",
                                            }}
                                          />
                                          <label className="m-0">
                                            Account Aggregator
                                          </label>
                                        </div>
                                        <div className="col-lg-6 col-md-6 gap-2 col-sm-12 d-flex align-items-center mt-2">
                                          <input
                                            type="radio"
                                            name="shipSpeed1"
                                            value="4"
                                            checked={furtherStatus === "4"}
                                            onChange={(e) =>
                                              setFurtherStatus(e.target.value)
                                            }
                                            style={{
                                              height: "18px",
                                              width: "18px",
                                            }}
                                          />
                                          <label className="m-0">Both</label>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  {/* <div className="d-flex gap-2 align-items-center mt-3 mb-2">
                                          <input
                                            type="radio"
                                            onClick={() =>
                                              setShowUploadModal(true)
                                            }
                                            style={{
                                              height: "18px",
                                              width: "18px",
                                            }}
                                          />
                                          <label className="m-0">
                                            Employer contact Details Upload
                                          </label>
                                        </div> */}
                                </td>
                              </tr>
                              <tr className="border">
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    border: "none",
                                  }}
                                >
                                  Remark:
                                </td>
                                <td
                                  style={{
                                    border: "none",
                                  }}
                                >
                                  <textarea
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                    style={{ width: "80%" }}
                                  />
                                </td>
                              </tr>
                              <tr className="border">
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    border: "none",
                                  }}
                                >
                                  Approval
                                </td>
                                <td
                                  style={{
                                    border: "none",
                                    textAlign: "center",
                                  }}
                                >
                                  <button
                                    className="btn btn-success"
                                    style={{ background: "black" }}
                                    onClick={() => setShowPasswordModal(true)}
                                  >
                                    Submit
                                  </button>
                                </td>
                              </tr>
                            </>
                          )}

                          <Modal
                            show={showUploadModal}
                            onHide={() => setShowUploadModal(false)}
                            centered
                            style={{ background: "#ffffffd1" }}
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>
                                Employer contact Details Upload
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <input
                                type="file"
                                onChange={handleDetailsChange}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  boxSizing: "border-box",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  marginTop: "10px",
                                }}
                              />
                              <div className="d-flex mt-3 justify-content-end">
                                <button
                                  className="btn btn-secondary"
                                  style={{ width: "100px" }}
                                  onClick={() => setShowUploadModal(false)}
                                >
                                  Cancel
                                </button>
                                <button
                                  className="btn btn-success ml-2"
                                  style={{
                                    width: "100px",
                                    background: "black",
                                  }}
                                  onClick={employerUploadContact}
                                >
                                  Submit
                                </button>
                              </div>
                            </Modal.Body>
                          </Modal>
                          <Modal
                            show={showPasswordModal}
                            onHide={() => setShowPasswordModal(false)}
                            centered
                            style={{ background: "#ffffffd1" }}
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Enter Password</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <input
                                type="password"
                                value={password}
                                onChange={handlePasswordChange}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  boxSizing: "border-box",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  marginTop: "10px",
                                }}
                              />
                              <div className="d-flex mt-3 justify-content-end">
                                <button
                                  className="btn btn-secondary"
                                  style={{ width: "100px" }}
                                  onClick={() => setShowPasswordModal(false)}
                                >
                                  Cancel
                                </button>
                                <button
                                  className="btn btn-success ml-2"
                                  style={{
                                    width: "100px",
                                    background: "black",
                                  }}
                                  onClick={handleSubmit}
                                >
                                  Submit
                                </button>
                              </div>
                            </Modal.Body>
                          </Modal>
                          <Modal
                            show={showApproveModal}
                            onHide={() => setShowApproveModal(false)}
                            centered
                            style={{ background: "#ffffffd1" }}
                          >
                            <Modal.Header closeButton>
                              <Modal.Title></Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ height: "120px" }}>
                              <div className="d-flex mt-3 justify-content-center">
                                <button
                                  className="btn btn-secondary"
                                  style={{
                                    background: "black",
                                  }}
                                  onClick={() => handleApprove("new")}
                                >
                                  New
                                </button>
                                <button
                                  className="btn btn-success ml-2"
                                  style={{
                                    background: "black",
                                  }}
                                  onClick={() => handleApprove("ignore")}
                                >
                                  Ignore
                                </button>
                              </div>
                            </Modal.Body>
                          </Modal>
                          <tr
                            className="border"
                            style={{ background: "black" }}
                          >
                            <td
                              style={{
                                fontWeight: "bold",
                                border: "none",
                              }}
                            >
                              Approval Status
                            </td>
                            <td
                              style={{
                                border: "none",
                                textAlign: "center",
                              }}
                            >
                              {data.cibli_status === 0 && (
                                <span>
                                  <span style={{ fontWeight: "bold" }}>
                                    Equifax Rejected
                                  </span>{" "}
                                  on {data.cibil_date}
                                </span>
                              )}
                              <span>
                                <span style={{ fontWeight: "bold" }}>
                                  Further Action
                                </span>{" "}
                                by
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      {/* {(data.grtApprovalStatus === 0 ||
        data.cibli_status === 0 ||
        data.creditstatus === 2 ||
        data.creditstatus === 3 ||
        data.isDeleted === 1) && (
        <Table bordered responsive style={{ width: "70%", marginLeft: "15%" }}>
          <tbody>
            <tr>
              <td style={{ fontWeight: "bold", borderRight: "none", borderTop: "none" }}>
                Remark:
              </td>
              <td style={{ borderLeft: "none", borderTop: "none", width: "60%" }}>
                {remark}
              </td>
            </tr>
            {[3, 4].includes(data.creditstatus) && (
              <tr>
                <td style={{ fontWeight: "bold", borderRight: "none" }}>
                  Reason
                </td>
                <td style={{ borderLeft: "none", textAlign: "center" }}>
                  {data.otherReason == null ? data.reason : data.otherReason}
                </td>
              </tr>
            )}
            <tr style={{ backgroundColor: "#A8BB21" }}>
              <td style={{ fontWeight: "bold", borderRight: "none" }}>
                Approval Status
              </td>
              <td style={{ borderLeft: "none", textAlign: "center" }}>
                {data.creditstatus === 2 && (
                  <span>
                    <span style={{ fontWeight: "bold" }}>TVR Approved</span> by {data.approvedbyname} ({data.approvedby}) on {data.sanctionletterdate}
                  </span>
                )}
                {data.creditstatus === 3 && (
                  <span>
                    <span style={{ fontWeight: "bold" }}>TVR Rejected</span> by {data.approvedbyname} ({data.approvedby}) on {data.sanctionletterdate} Reason- {data.reason}
                  </span>
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      )} */}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <Modal
        show={showModalSA}
        onHide={() => setShowModalSA(false)}
        style={{ background: "rgb(255 255 255 / 40%)" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Staff ID Input */}
          <input
            type="text"
            value={staffId}
            onChange={(e) => setStaffId(e.target.value)}
            placeholder="Enter Staff ID"
            style={{
              width: "100%",
              padding: "10px",
              boxSizing: "border-box",
              border: "1px solid #ccc",
              borderRadius: "4px",
              marginTop: "10px",
              fontSize: "18px",
            }}
          />

          {/* Loan Amount Inputs */}
          {/* <input
            type="number"
            value={limitExtend}
            onChange={(e) => setLimitExtend(e.target.value)}
            placeholder="Enter Loan Amount"
            style={{
              width: "100%",
              padding: "10px",
              boxSizing: "border-box",
              border: "1px solid #ccc",
              borderRadius: "4px",
              marginTop: "10px",
              fontSize: "18px",
            }}
          /> */}
          {console.log("limitExtend::: ", limitExtend)}
          <select
            className="form-select mt-2"
            id="options"
            onChange={(e) => setLimitExtend(e.target.value)}
            value={limitExtend}
          >
            <option value={0}>select</option>

            <option value={5000}>5000</option>
            <option value={10000}>10000</option>
          </select>

          <div className="d-flex mt-3 justify-content-end">
            <button
              className="btn btn-secondary"
              style={{ width: "100px" }}
              onClick={() => setShowModalSA(false)}
            >
              Cancel
            </button>
            <button
              className="btn btn-success ml-2"
              style={{ width: "100px", background: "#66a725" }}
              onClick={handleSubmitSA}
            >
              Submit
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showModalImg}
        onHide={() => setShowModalImg(false)}
        style={{ background: "rgb(255 255 255 / 40%)" }}
      >
        <Modal.Header closeButton>
          <Modal.Title> {imgUrl?.doctype}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Staff ID Input */}
          <img
            className="card-img-top p-2"
            src={imgUrl?.doclink}
            alt="Document Preview"
            style={{
              height: "500px",
              width: "100%",
              objectFit: "contain",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              backgroundColor: "#f8f9fa",
            }}
          />

          {/* Loan Amount Inputs */}

          <div className="d-flex mt-3 justify-content-end">
            <button
              className="btn btn-secondary"
              style={{ width: "100px" }}
              onClick={() => setShowModalImg(false)}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary ml-2"
              style={{ width: "100px" }}
              onClick={() => window.open(imgUrl?.doclink, "_blank")}
            >
              Download
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={model1}
        onHide={() => setModel1(false)}
        style={{ background: "rgb(255 255 255 / 40%)" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>GST Verify</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Staff ID Input */}
          <input
            type="text"
            placeholder="GST Number"
            value={gstNumber}
            onChange={(e) => setGstNumber(e.target.value)}
          />

          {/* Loan Amount Inputs */}

          <div className="d-flex mt-3 justify-content-end">
            <button
              className="btn btn-secondary"
              style={{ width: "100px" }}
              onClick={() => setModel1(false)}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary ml-2"
              style={{ width: "100px" }}
              onClick={() => validateGSTIN()}
            >
              verify
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={model2}
        onHide={() => setModel2(false)}
        style={{ background: "rgb(255 255 255 / 40%)" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Udyam Verify</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Staff ID Input */}
          <input
            type="text"
            placeholder="Udyam Number"
            value={udhaym}
            onChange={(e) => setUdhaym(e.target.value)}
          />

          {/* Loan Amount Inputs */}

          <div className="d-flex mt-3 justify-content-end">
            <button
              className="btn btn-secondary"
              style={{ width: "100px" }}
              onClick={() => setModel2(false)}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary ml-2"
              style={{ width: "100px" }}
              onClick={() => validateUdyam()}
            >
              verify
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default CaPending;
